<template>
    <div class="w-full pl-2 pr-2">
        <p class="mb-2 text-sm">
            カード裏面のご署名欄に印字された数字の末尾3桁<br/>
            (AMEXカードの場合はカード表面の4桁)
        </p>
        <img src="/images/security_code.png" class="w-80 max-w-full" alt="セキュリティコード">
    </div>
</template>

<script>
export default {
    name: "SecurityCodeInformation"
}
</script>

<style scoped>

</style>
